import type { LinkData } from '@packages/cms-components/interfaces';
import { logger } from '@packages/shared';
import encodeToBase64 from './encodeToBase64';

/**
 * Builds a link with data from drupal for the current URL
 *
 * @param currentURL The current URL incluuding any query parameters
 * @param linkArguments LinkData from Drupal (like tracking, bonusnumber, highlight)
 * @returns Complete URL string
 */
const buildLinkWithArguments = (
  currentURL: string | null,
  linkArguments: Partial<LinkData> = {},
): string => {
  const {
    field_link: link,
    field_link_anchor: linkAnchor,
    field_link_highlight: linkHighlight,
    field_link_searchfilter: linkSearchfilter,
    field_tracking: linkTracking,
    field_bonus_number: bonusNumber,
  } = linkArguments;

  try {
    const url = new URL(currentURL || link || '/');
    const encodedBonusCode = encodeToBase64(bonusNumber);
    const searchParams = new URLSearchParams(url.search);

    const urlPercentEncodedString = new URLSearchParams({
      ...(linkHighlight && { highlight: linkHighlight }),
      ...(linkSearchfilter && { f: linkSearchfilter }),
      ...(encodedBonusCode && { P1: encodedBonusCode }),
      ...(linkTracking && { lmPromo: linkTracking }),
      // Transform URLSearchParam instance into a plain JavaScript object
      ...Object.fromEntries(searchParams.entries()),
    }).toString();

    url.search = decodeURIComponent(urlPercentEncodedString);
    url.hash = linkAnchor || url.hash || '';

    return url.href;
  } catch (e) {
    logger.warn(e, 'Error building link');
    return '';
  }
};

export { buildLinkWithArguments };
